/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Users API
 * Users API
 * OpenAPI spec version: 1.24.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddStaff200,
  AddStaffToStore200,
  GetAuthRoles200,
  GetEmailStatus200,
  GetEmailStatusParams,
  GetShiftLeads200,
  GetStaff200,
  GetStaffStores200,
  GetStaffStoresParams,
  RequestPINReset200,
  RequestPasswordReset200,
  ShiftLead200,
  StaffManagementAddStaffToStoreRequest,
  StaffManagementCreateStaffRequest,
  StaffManagementPINResetRequest,
  StaffManagementRequestPasswordResetRequest,
  StaffManagementUpdateStaffRequest,
  StaffShiftLeadRequest,
  StaffShiftLeadUpdateRequest,
  UpdateShiftLead200,
  UpdateStaff200
} from './users-api.schemas';

import { usersApiInstance } from '../../common/axios/orvalMutator';
import type { ErrorType, BodyType } from '../../common/axios/orvalMutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get list of roles that can be assigned to staff. Only ADMIN and MANAGER can access this endpoint.
 * @summary Get roles list.
 */
export const getAuthRoles = (
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<GetAuthRoles200>(
    { url: `/staff-management/roles`, method: 'GET' },
    options
  );
};

export const getGetAuthRolesQueryKey = () => {
  return [`/staff-management/roles`] as const;
};

export const getGetAuthRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthRoles>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAuthRoles>>, TError, TData>
  >;
  request?: SecondParameter<typeof usersApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuthRolesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthRoles>>> = () =>
    getAuthRoles(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAuthRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthRoles>>
>;
export type GetAuthRolesQueryError = ErrorType<unknown>;

export function useGetAuthRoles<
  TData = Awaited<ReturnType<typeof getAuthRoles>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthRoles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthRoles>>,
          TError,
          Awaited<ReturnType<typeof getAuthRoles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthRoles<
  TData = Awaited<ReturnType<typeof getAuthRoles>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthRoles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthRoles>>,
          TError,
          Awaited<ReturnType<typeof getAuthRoles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthRoles<
  TData = Awaited<ReturnType<typeof getAuthRoles>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthRoles>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get roles list.
 */

export function useGetAuthRoles<
  TData = Awaited<ReturnType<typeof getAuthRoles>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthRoles>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAuthRolesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Check if staff user already exists. 'type' field in response returns 'known' or 'unknown'. If 'known', returns staff info else null. Only ADMIN and MANAGER can access this endpoint.
 * @summary Lookup staff by username/email.
 */
export const getEmailStatus = (
  params: GetEmailStatusParams,
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<GetEmailStatus200>(
    { url: `/staff-management/email-status`, method: 'GET', params },
    options
  );
};

export const getGetEmailStatusQueryKey = (params?: GetEmailStatusParams) => {
  return [
    `/staff-management/email-status`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetEmailStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailStatus>>,
  TError = ErrorType<unknown>
>(
  params: GetEmailStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmailStatus>>
  > = () => getEmailStatus(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEmailStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailStatus>>
>;
export type GetEmailStatusQueryError = ErrorType<unknown>;

export function useGetEmailStatus<
  TData = Awaited<ReturnType<typeof getEmailStatus>>,
  TError = ErrorType<unknown>
>(
  params: GetEmailStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailStatus>>,
          TError,
          Awaited<ReturnType<typeof getEmailStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEmailStatus<
  TData = Awaited<ReturnType<typeof getEmailStatus>>,
  TError = ErrorType<unknown>
>(
  params: GetEmailStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailStatus>>,
          TError,
          Awaited<ReturnType<typeof getEmailStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEmailStatus<
  TData = Awaited<ReturnType<typeof getEmailStatus>>,
  TError = ErrorType<unknown>
>(
  params: GetEmailStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup staff by username/email.
 */

export function useGetEmailStatus<
  TData = Awaited<ReturnType<typeof getEmailStatus>>,
  TError = ErrorType<unknown>
>(
  params: GetEmailStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEmailStatusQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List of all staff at store. For each staff, returns staff info and list of stores(storeId's) the staff has access to. Only ADMIN and MANAGER can access this endpoint.
 * @summary Get list of staff at jwt store
 */
export const getStaff = (
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<GetStaff200>(
    { url: `/staff-management/staff`, method: 'GET' },
    options
  );
};

export const getGetStaffQueryKey = () => {
  return [`/staff-management/staff`] as const;
};

export const getGetStaffQueryOptions = <
  TData = Awaited<ReturnType<typeof getStaff>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getStaff>>, TError, TData>
  >;
  request?: SecondParameter<typeof usersApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStaffQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStaff>>> = () =>
    getStaff(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStaff>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStaffQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStaff>>
>;
export type GetStaffQueryError = ErrorType<unknown>;

export function useGetStaff<
  TData = Awaited<ReturnType<typeof getStaff>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStaff>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStaff>>,
          TError,
          Awaited<ReturnType<typeof getStaff>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStaff<
  TData = Awaited<ReturnType<typeof getStaff>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStaff>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStaff>>,
          TError,
          Awaited<ReturnType<typeof getStaff>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStaff<
  TData = Awaited<ReturnType<typeof getStaff>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStaff>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get list of staff at jwt store
 */

export function useGetStaff<
  TData = Awaited<ReturnType<typeof getStaff>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStaff>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStaffQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates new staff user and adds them to store. Sends invite email to create password. If staff user already exists, then just assign them to store. Only ADMIN and MANAGER can access this endpoint.
 * @summary Create staff and add them to store
 */
export const addStaff = (
  staffManagementCreateStaffRequest: BodyType<StaffManagementCreateStaffRequest>,
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<AddStaff200>(
    {
      url: `/staff-management/staff`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffManagementCreateStaffRequest
    },
    options
  );
};

export const getAddStaffMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addStaff>>,
    TError,
    { data: BodyType<StaffManagementCreateStaffRequest> },
    TContext
  >;
  request?: SecondParameter<typeof usersApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addStaff>>,
  TError,
  { data: BodyType<StaffManagementCreateStaffRequest> },
  TContext
> => {
  const mutationKey = ['addStaff'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addStaff>>,
    { data: BodyType<StaffManagementCreateStaffRequest> }
  > = props => {
    const { data } = props ?? {};

    return addStaff(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddStaffMutationResult = NonNullable<
  Awaited<ReturnType<typeof addStaff>>
>;
export type AddStaffMutationBody = BodyType<StaffManagementCreateStaffRequest>;
export type AddStaffMutationError = ErrorType<unknown>;

/**
 * @summary Create staff and add them to store
 */
export const useAddStaff = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addStaff>>,
      TError,
      { data: BodyType<StaffManagementCreateStaffRequest> },
      TContext
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addStaff>>,
  TError,
  { data: BodyType<StaffManagementCreateStaffRequest> },
  TContext
> => {
  const mutationOptions = getAddStaffMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update staff info. Required PIN and staff id. All other fields are optional. Only ADMIN and MANAGER can access this endpoint.
 * @summary Update Staff Info. Setting 'endDate' null will undo remove staff from store.
 */
export const updateStaff = (
  staffManagementUpdateStaffRequest: BodyType<StaffManagementUpdateStaffRequest>,
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<UpdateStaff200>(
    {
      url: `/staff-management/staff`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffManagementUpdateStaffRequest
    },
    options
  );
};

export const getUpdateStaffMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStaff>>,
    TError,
    { data: BodyType<StaffManagementUpdateStaffRequest> },
    TContext
  >;
  request?: SecondParameter<typeof usersApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStaff>>,
  TError,
  { data: BodyType<StaffManagementUpdateStaffRequest> },
  TContext
> => {
  const mutationKey = ['updateStaff'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStaff>>,
    { data: BodyType<StaffManagementUpdateStaffRequest> }
  > = props => {
    const { data } = props ?? {};

    return updateStaff(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStaffMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStaff>>
>;
export type UpdateStaffMutationBody =
  BodyType<StaffManagementUpdateStaffRequest>;
export type UpdateStaffMutationError = ErrorType<unknown>;

/**
 * @summary Update Staff Info. Setting 'endDate' null will undo remove staff from store.
 */
export const useUpdateStaff = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateStaff>>,
      TError,
      { data: BodyType<StaffManagementUpdateStaffRequest> },
      TContext
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateStaff>>,
  TError,
  { data: BodyType<StaffManagementUpdateStaffRequest> },
  TContext
> => {
  const mutationOptions = getUpdateStaffMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns stores list. Has to be ADMIN or MANAGER if requesting for other staff member.
 * @summary Get stores list
 */
export const getStaffStores = (
  params: GetStaffStoresParams,
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<GetStaffStores200>(
    { url: `/staff-management/staff-stores`, method: 'GET', params },
    options
  );
};

export const getGetStaffStoresQueryKey = (params?: GetStaffStoresParams) => {
  return [
    `/staff-management/staff-stores`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetStaffStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof getStaffStores>>,
  TError = ErrorType<unknown>
>(
  params: GetStaffStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStaffStores>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStaffStoresQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStaffStores>>
  > = () => getStaffStores(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStaffStores>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStaffStoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStaffStores>>
>;
export type GetStaffStoresQueryError = ErrorType<unknown>;

export function useGetStaffStores<
  TData = Awaited<ReturnType<typeof getStaffStores>>,
  TError = ErrorType<unknown>
>(
  params: GetStaffStoresParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStaffStores>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStaffStores>>,
          TError,
          Awaited<ReturnType<typeof getStaffStores>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStaffStores<
  TData = Awaited<ReturnType<typeof getStaffStores>>,
  TError = ErrorType<unknown>
>(
  params: GetStaffStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStaffStores>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStaffStores>>,
          TError,
          Awaited<ReturnType<typeof getStaffStores>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStaffStores<
  TData = Awaited<ReturnType<typeof getStaffStores>>,
  TError = ErrorType<unknown>
>(
  params: GetStaffStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStaffStores>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get stores list
 */

export function useGetStaffStores<
  TData = Awaited<ReturnType<typeof getStaffStores>>,
  TError = ErrorType<unknown>
>(
  params: GetStaffStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStaffStores>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStaffStoresQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Assign staff to store. Only ADMIN and MANAGER can access this endpoint.
 * @summary Add staff to store
 */
export const addStaffToStore = (
  staffManagementAddStaffToStoreRequest: BodyType<StaffManagementAddStaffToStoreRequest>,
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<AddStaffToStore200>(
    {
      url: `/staff-management/staff/add-to-store`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffManagementAddStaffToStoreRequest
    },
    options
  );
};

export const getAddStaffToStoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addStaffToStore>>,
    TError,
    { data: BodyType<StaffManagementAddStaffToStoreRequest> },
    TContext
  >;
  request?: SecondParameter<typeof usersApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addStaffToStore>>,
  TError,
  { data: BodyType<StaffManagementAddStaffToStoreRequest> },
  TContext
> => {
  const mutationKey = ['addStaffToStore'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addStaffToStore>>,
    { data: BodyType<StaffManagementAddStaffToStoreRequest> }
  > = props => {
    const { data } = props ?? {};

    return addStaffToStore(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddStaffToStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof addStaffToStore>>
>;
export type AddStaffToStoreMutationBody =
  BodyType<StaffManagementAddStaffToStoreRequest>;
export type AddStaffToStoreMutationError = ErrorType<unknown>;

/**
 * @summary Add staff to store
 */
export const useAddStaffToStore = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addStaffToStore>>,
      TError,
      { data: BodyType<StaffManagementAddStaffToStoreRequest> },
      TContext
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addStaffToStore>>,
  TError,
  { data: BodyType<StaffManagementAddStaffToStoreRequest> },
  TContext
> => {
  const mutationOptions = getAddStaffToStoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const requestPasswordReset = (
  staffManagementRequestPasswordResetRequest: BodyType<StaffManagementRequestPasswordResetRequest>,
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<RequestPasswordReset200>(
    {
      url: `/staff-management/request-password-reset`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffManagementRequestPasswordResetRequest
    },
    options
  );
};

export const getRequestPasswordResetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: BodyType<StaffManagementRequestPasswordResetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof usersApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: BodyType<StaffManagementRequestPasswordResetRequest> },
  TContext
> => {
  const mutationKey = ['requestPasswordReset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    { data: BodyType<StaffManagementRequestPasswordResetRequest> }
  > = props => {
    const { data } = props ?? {};

    return requestPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestPasswordReset>>
>;
export type RequestPasswordResetMutationBody =
  BodyType<StaffManagementRequestPasswordResetRequest>;
export type RequestPasswordResetMutationError = ErrorType<unknown>;

export const useRequestPasswordReset = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestPasswordReset>>,
      TError,
      { data: BodyType<StaffManagementRequestPasswordResetRequest> },
      TContext
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: BodyType<StaffManagementRequestPasswordResetRequest> },
  TContext
> => {
  const mutationOptions = getRequestPasswordResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Request to reset pin. pin and staffId are required in payload if requesting reset for someone else. Not needed if requesting for self
 * @summary Reset pin for self or manager requesting for someone else
 */
export const requestPINReset = (
  staffManagementPINResetRequest: BodyType<StaffManagementPINResetRequest>,
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<RequestPINReset200>(
    {
      url: `/staff-management/reset-pin`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffManagementPINResetRequest
    },
    options
  );
};

export const getRequestPINResetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPINReset>>,
    TError,
    { data: BodyType<StaffManagementPINResetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof usersApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestPINReset>>,
  TError,
  { data: BodyType<StaffManagementPINResetRequest> },
  TContext
> => {
  const mutationKey = ['requestPINReset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestPINReset>>,
    { data: BodyType<StaffManagementPINResetRequest> }
  > = props => {
    const { data } = props ?? {};

    return requestPINReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPINResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestPINReset>>
>;
export type RequestPINResetMutationBody =
  BodyType<StaffManagementPINResetRequest>;
export type RequestPINResetMutationError = ErrorType<unknown>;

/**
 * @summary Reset pin for self or manager requesting for someone else
 */
export const useRequestPINReset = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestPINReset>>,
      TError,
      { data: BodyType<StaffManagementPINResetRequest> },
      TContext
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof requestPINReset>>,
  TError,
  { data: BodyType<StaffManagementPINResetRequest> },
  TContext
> => {
  const mutationOptions = getRequestPINResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get all shift leads for the current day and session store.
 */
export const getShiftLeads = (
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<GetShiftLeads200>(
    { url: `/staff-management/shift-leads`, method: 'GET' },
    options
  );
};

export const getGetShiftLeadsQueryKey = () => {
  return [`/staff-management/shift-leads`] as const;
};

export const getGetShiftLeadsQueryOptions = <
  TData = Awaited<ReturnType<typeof getShiftLeads>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getShiftLeads>>, TError, TData>
  >;
  request?: SecondParameter<typeof usersApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetShiftLeadsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getShiftLeads>>
  > = () => getShiftLeads(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getShiftLeads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetShiftLeadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShiftLeads>>
>;
export type GetShiftLeadsQueryError = ErrorType<unknown>;

export function useGetShiftLeads<
  TData = Awaited<ReturnType<typeof getShiftLeads>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getShiftLeads>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShiftLeads>>,
          TError,
          Awaited<ReturnType<typeof getShiftLeads>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetShiftLeads<
  TData = Awaited<ReturnType<typeof getShiftLeads>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getShiftLeads>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShiftLeads>>,
          TError,
          Awaited<ReturnType<typeof getShiftLeads>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetShiftLeads<
  TData = Awaited<ReturnType<typeof getShiftLeads>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getShiftLeads>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all shift leads for the current day and session store.
 */

export function useGetShiftLeads<
  TData = Awaited<ReturnType<typeof getShiftLeads>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getShiftLeads>>, TError, TData>
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetShiftLeadsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a shift lead for the current day.
 */
export const shiftLead = (
  staffShiftLeadRequest: BodyType<StaffShiftLeadRequest>,
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<ShiftLead200>(
    {
      url: `/staff-management/shift-leads`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffShiftLeadRequest
    },
    options
  );
};

export const getShiftLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shiftLead>>,
    TError,
    { data: BodyType<StaffShiftLeadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof usersApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shiftLead>>,
  TError,
  { data: BodyType<StaffShiftLeadRequest> },
  TContext
> => {
  const mutationKey = ['shiftLead'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shiftLead>>,
    { data: BodyType<StaffShiftLeadRequest> }
  > = props => {
    const { data } = props ?? {};

    return shiftLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShiftLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof shiftLead>>
>;
export type ShiftLeadMutationBody = BodyType<StaffShiftLeadRequest>;
export type ShiftLeadMutationError = ErrorType<unknown>;

/**
 * @summary Create a shift lead for the current day.
 */
export const useShiftLead = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof shiftLead>>,
      TError,
      { data: BodyType<StaffShiftLeadRequest> },
      TContext
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof shiftLead>>,
  TError,
  { data: BodyType<StaffShiftLeadRequest> },
  TContext
> => {
  const mutationOptions = getShiftLeadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update the end time of a current day's shift lead.
 */
export const updateShiftLead = (
  staffShiftLeadUpdateRequest: BodyType<StaffShiftLeadUpdateRequest>,
  options?: SecondParameter<typeof usersApiInstance>
) => {
  return usersApiInstance<UpdateShiftLead200>(
    {
      url: `/staff-management/shift-leads`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffShiftLeadUpdateRequest
    },
    options
  );
};

export const getUpdateShiftLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateShiftLead>>,
    TError,
    { data: BodyType<StaffShiftLeadUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof usersApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateShiftLead>>,
  TError,
  { data: BodyType<StaffShiftLeadUpdateRequest> },
  TContext
> => {
  const mutationKey = ['updateShiftLead'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateShiftLead>>,
    { data: BodyType<StaffShiftLeadUpdateRequest> }
  > = props => {
    const { data } = props ?? {};

    return updateShiftLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateShiftLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateShiftLead>>
>;
export type UpdateShiftLeadMutationBody = BodyType<StaffShiftLeadUpdateRequest>;
export type UpdateShiftLeadMutationError = ErrorType<unknown>;

/**
 * @summary Update the end time of a current day's shift lead.
 */
export const useUpdateShiftLead = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateShiftLead>>,
      TError,
      { data: BodyType<StaffShiftLeadUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof usersApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateShiftLead>>,
  TError,
  { data: BodyType<StaffShiftLeadUpdateRequest> },
  TContext
> => {
  const mutationOptions = getUpdateShiftLeadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
